var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('router-link',{attrs:{"to":"/covid-relief"}},[_vm._v("Change your bottom line. Click for Covid relief fees.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }